module.exports = __webpack_public_path__ + "static/media/brand-story-meaning11.a40414b7.png";